export const addNumberIsIntegerPolyfill = () => {
    Number.isInteger = Number.isInteger || function(value) {
        return typeof value === 'number' && 
            isFinite(value) && 
            Math.floor(value) === value;
    };
};
